/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualValidationStillNeededRequestDto
 */
export interface ManualValidationStillNeededRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof ManualValidationStillNeededRequestDto
     */
    workflowInstanceId: string;
    /**
     * Numeric metric of the solution
     * @type {number}
     * @memberof ManualValidationStillNeededRequestDto
     */
    score: number;
    /**
     * Human-readable report of automated operation
     * @type {string}
     * @memberof ManualValidationStillNeededRequestDto
     */
    report: string;
}

/**
 * Check if a given object implements the ManualValidationStillNeededRequestDto interface.
 */
export function instanceOfManualValidationStillNeededRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('score' in value)) return false;
    if (!('report' in value)) return false;
    return true;
}

export function ManualValidationStillNeededRequestDtoFromJSON(json: any): ManualValidationStillNeededRequestDto {
    return ManualValidationStillNeededRequestDtoFromJSONTyped(json, false);
}

export function ManualValidationStillNeededRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualValidationStillNeededRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'score': json['score'],
        'report': json['report'],
    };
}

export function ManualValidationStillNeededRequestDtoToJSON(value?: ManualValidationStillNeededRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'score': value['score'],
        'report': value['report'],
    };
}

